// 3rd party
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.css']
})
export class ErrorDialogComponent {

  icon: string;
  iconColor: string;
  message: string;
  title: string;

  constructor(
    public dialogRef: MatDialogRef<ErrorDialogComponent>,
    public translate: TranslateService
  ) { }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/error-dialog/error-dialog.component.ts